"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUERY_PICK_LIST = exports.QUERY_ATTESTATIONS = exports.QUERY_ENTRY_LEVEL = exports.GET_CONTENTFUL_PRODUCT = exports.GET_PROMOCODE_DETAILS_BY_PROMOCODE = exports.QUERY_MEMBERSHIP_TIER_BENEFITS = exports.QUERY_MEMBERSHIP_PRODUCT_BLOCK = exports.QUERY_STATIC_LANDING_PAGE = exports.GET_CONTENT_BLOGS = exports.GET_BRAND_IMAGE = exports.GET_TOOLKIT_PAGE = exports.GET_RICH_TEXT = exports.QUERY_LANDING_PAGE = exports.QUERY_PRODUCT_AGGS_PAGE_CONTENT = exports.QUERY_AGGS_PAGE_CONTENT = exports.GET_RELATED_CONTENT = exports.GET_STATIC_CONTENT_ITEM = exports.GET_CONTENT_ITEM = exports.QUERY_CONTENT_BY_PREF = exports.GET_CONTENT = void 0;
const contentCardFields = `
  id,
  slug,
  contentfulType,
  contentType {
    name
    slug
  },
  title,
  dateCreated,
  contentCategory {
    name,
    slug,
  }
  image {
    altText,
    caption,
    credit,
    title,
    url
  }
  description,
  timeToConsume,
  credits,
  productType,
  availableFormat,
  startDate,
  endDate,
  prices {
    currency
    amount
    channel {
      applicableUserRoles
      id
    }
    custom
  },
  externalUrl,
  contentSource,
  level,
  variantsCount,
  conferenceCity,
  conferenceState,
  downloads{
    fileSize
  }
  roles,
  matchedRoles,
  isLocked,
  parentProductInfo {
    sessions,
    upcomingDates
  },
  restrictionDetails {
    role
    membershipType
    learnMoreUrl
  },
  topicalSubscriptions,
  bundleInfo {
    prices,
    bundleDiscountPercent,
    numberOfComponentProducts,
  },
  fundName
  applyFreeTrial
`;
const promoComponentFields = `
  id
  header
  headerMembership
  summary
  summaryMembership
  ctaText
  ctaTextMembership
  ctaUrl
  ctaUrlMembership
  membership
`;
const promoListFields = `
  id
  name
  list{
    id
    title
    url
  }
`;
const video = `
  brightcove {
    type
    id
    playerTypeIdOverride
  }
  embedCode
`;
const testimonial = `
  media {
    title
    image
    video {
      ${video}
    }
  }
  author
  role
  quote
`;
exports.GET_CONTENT = `
  {
    content {
      id
      title
    }
  }
`;
const benefitsSubBlock = `
{
  name header description url oplLink
  image {
    title
    description
    url
  }
  imageMembership {
    title
    description
    url
  }
}`;
exports.QUERY_CONTENT_BY_PREF = `
  query getContentByPref($page: Int, $perPage: Int, $filters: Filters) {
    getContentByPref(page: $page, perPage: $perPage, filters: $filters) {
      results {
        id,
        title,
        subtitle,
        description,
        availableFormat,
        level,
        variantsCount,
        startDate,
        endDate,
        prices {
          currency
          amount
          channel {
            applicableUserRoles
            id
          }
        },
        externalUrl,
        contentSource,
        credits,
        contentfulType,
        contentType {
          name
          slug
        },
        slug,
        image: featuredImage {
          altText
          caption
          credit
          title
          url
        }
        contentCategory {
          name
          slug
        }
        topics {
          id,
          name,
          slug
        }
        subtopics {
          id,
          name,
          slug
          topicId
          topicSlug
        },
        industries {
          id,
          name,
          slug
        },
        trends {
          id,
          name,
          slug
        },
        skills {
          id,
          name,
          slug
        },
        subskills {
          id,
          name,
          slug
          skillId
          skillSlug
        },
        roles,
        matchedRoles,
        isLocked,
        timeToConsume,
        dateCreated,
        productType,
        country,
        conferenceState,
        conferenceCity,
        fundName,
        downloads{
          fileSize
        },
        parentProductInfo {
          sessions,
          upcomingDates
        },
        restrictionDetails {
          role
          membershipType
          learnMoreUrl
        },
        topicalSubscriptions,
        hasSectionAccessRestriction,
        applyFreeTrial,
      },
      meta {
        aggs,
        total,
        perPage,
        page
      }
    }
  }
`;
exports.GET_CONTENT_ITEM = `
  query contentItemBySlug($slug: String, $category: String, $type: String) {
    getContentItemBySlug(slug: $slug, category: $category, type: $type) {
      id
      description
      contentfulType
      contentType {
        name
        slug
      }
      title
      dateCreated
      contentAuthor {
        name
        credentials
        jobTitle
        authorBio
      }
      contentCategory {
        name
        slug
      }
      contentSource
      image {
        altText
        caption
        credit
        title
        url
      }
      topics {
        id
        name
        slug
      }
      subtopics {
        id
        name
        slug
        topicId
        topicSlug
      }
      trends {
        id,
        name,
        slug
      }
      industries {
        id,
        name,
        slug
      }
      skills {
        id,
        name,
        slug
      }
      subskills {
        id,
        name,
        slug
        skillId
        skillSlug
      }
      standFirst
      subtitleText
      pageCopy
      timeToConsume
      audio
      video {
        brightcove {
          type
          id
          playerTypeIdOverride
        }
        embedCode
      }
      videoAddOn {
        brightcove {
          type
          id
          playerTypeIdOverride
        }
        embedCode
      }
      roles
      matchedRoles
      isLocked
      slug
      downloads {
        name
        fileNames
        buttonText
        fileLink
        fileSize
      }
      restrictionDetails {
        role
        membershipType
        learnMoreUrl
      }
      topicalSubscriptions
      isAppointmentCalendarPage
      externalAdsConfig
      noIndex
    }
  }
`;
exports.GET_STATIC_CONTENT_ITEM = `
  query getContentItemBySlug($slug: String, $type: String) {
    getContentItemBySlug(slug: $slug, type: $type) {
      id
      contentType {
        name
        slug
      }
      title
      image {
        altText
        caption
        credit
        title
        url
      }
      subtitleText
      standFirst
      pageCopy
      roles
      isLocked
    }
  }
`;
exports.GET_RELATED_CONTENT = `
  query getRelatedContent($topics: [String], $subtopics: [String], $excludeIds: [String]) {
    getRelatedContent(topics: $topics, subtopics: $subtopics, excludeIds: $excludeIds) {
      ${contentCardFields}
    }
  }
`;
exports.QUERY_AGGS_PAGE_CONTENT = `
  query getAggsPageContent($topicId: String, $subtopicId: String, $industryId: String, $trendId: String, $skillId: String, $subskillId: String, $topicSlugs: [String], $industrySlugs: [String], $trendSlugs: [String], $skillSlugs: [String]) {
    getAggsPageContent(topicId: $topicId, subtopicId: $subtopicId, industryId: $industryId, trendId: $trendId, skillId: $skillId, subskillId: $subskillId, topicSlugs: $topicSlugs, industrySlugs: $industrySlugs, trendSlugs: $trendSlugs, skillSlugs: $skillSlugs) {
      topicSummary
      editorialBlockItems {
        ${contentCardFields}
      }
      heroCategorySummary
      heroCategoryItems {
        ${contentCardFields}
      }
      leftSectionToolkitLinks {
        ${contentCardFields}
      }
      leftSectionPromoItems {
        ${promoComponentFields}
      }
      bottomPromoItems {
        ${promoComponentFields}
      }
      mainSectionItems {
        ${contentCardFields}
      }
      bottomPromoLists {
        ${promoListFields}
      }
      useParentTopicConfig
      topicContentList{
        title
        slug
      }
      industryContentList{
        title
        slug
      }
      trendContentList{
        title
        slug
      }
      skillContentList{
        title
        slug
      }
      associatedMembershipRestrictions {
        name
        slug
        oktaRoleId
        header
        joinPromptText
        benefitList
        headerSectionMember
        headerMember
        headerNonMember
        headerLoggedOut
        ctaDescriptionMember
        ctaDescriptionNonMembers
        ctaDescriptionLoggedOut
        becomeMemberButton
        ctaUrlNonMember
        learnMoreLink
        benefitsSubBlock ${benefitsSubBlock}
      }
      ogImage
      externalAdsConfig
      slicedTopics {
        id
        name
        slug
      }
      slicedIndustries {
        id
        name
        slug
      }
      slicedTrends {
        id
        name
        slug
      }
      slicedSkills {
        id
        name
        slug
      }
      image
    }
  }
`;
exports.QUERY_PRODUCT_AGGS_PAGE_CONTENT = `
  query getProductAggsPageContent($topicId: String, $productTypeId: String) {
    getProductAggsPageContent(topicId: $topicId, productTypeId: $productTypeId) {
      title
      summary
      metaTitle
      metaDescription
      mainSectionSlugs
      mainSectionItems {
        ${contentCardFields}
      }
      mainSectionProductTypesAndPromotionalComponents {
        contentType
        slug
        certificateProgram
        name
        header
        headerMembership
        summary
        summaryMembership
        productTypeKeys
      }
      ogImage
      externalAdsConfig
      image
    }
  }
`;
exports.QUERY_LANDING_PAGE = `
  query getLandingPage($slug: String, $useDynamicTrending: Boolean, $isPageStorefront: Boolean) {
    getLandingPage(slug: $slug, useDynamicTrending: $useDynamicTrending, isPageStorefront: $isPageStorefront) {
      title
      metaTitle
      default
      metaDescription
      useFullPagePagination
      landingPageBlocks {
        id
        style
        contentType
        title
        accordion
        bodyCopy
        image
        testimonials {
          ${testimonial}
        }
        video {
          ${video}
        }
        videoAddOn {
          ${video}
        }
        bgColor
        contentAlignment
        header
        description
        ctaText
        ctaUrl
        headerText
        mainText
        headerOnboarded
        headerNonOnboarded
        descriptionText
        descriptionOnboarded
        descriptionNonOnboarded
        ctaTextOnboarded
        ctaTextNonOnboarded
        ctaUrlOnboarded
        ctaUrlNonOnboarded
        advancedTable
        stat1LargeText
        stat2LargeText
        stat2SmallText
        stat3LargeText
        stat3SmallText
        stat4LargeText
        stat4SmallText
        rotation
        products{
          ${contentCardFields}
        }
        contents {
          ${contentCardFields}
        }
        cmsProducts {
          ... on CmsProduct {
            slug
            image {
              url
              altText
            }
            benefits ${benefitsSubBlock}
          }
          ... on ContentItem {
            ${contentCardFields}
          }
        }
        topicList {
          id
          name
          slug
          storefrontImage
          storefrontDescription
        }
        productTypeList {
          id
          name
          slug
          storefrontImage
          storefrontDescription
        }
        landingPageSubBlocks {
          id
          image
          colourway
          header
          description
          ctaText
          ctaUrl
        }
        welcomeBannerSubBlocks {
          id
          headingTag
          heading
          subHeading
          description
          image
          ctaText
          ctaUrl
        }
        inquiryForm
        campaignId
        anchorSlug
        submitUrl
        contentReference {
          ${contentCardFields}
        }
        componentList {
          id
          title
          description
          contentfulType
          contentType {
            name
            slug
            description
          }
          contentCategory {
            name
            slug
            description
          }
          image {
            altText
            caption
            credit
            title
            url
          }
          dateCreated
          timeToConsume
          slug
          productType
          credits
          availableFormat
          externalUrl
          url
          contentSource
          startPrice
          endPrice
          prices {
            currency
            amount
            channel {
              applicableUserRoles
              id
            }
          }
          startDate
          endDate
          level
          conferenceState
          conferenceCity
          downloads {
            name
            fileNames
            buttonText
            fileLink
            fileSize
          }
          variantsCount
          firstTopic
          roles
          matchedRoles
          isLocked
          parentProductInfo {
            sessions
            upcomingDates
          }
          restrictionDetails {
            role
            membershipType
            learnMoreUrl
          }
          topicalSubscriptions
          hasSectionAccessRestriction
          originProductType
          showQuantity
          bundleCardInfo {
            prices
            bundleDiscountPercent
            numberOfComponentProducts
          }
          bundleInfo {
            prices
            bundleDiscountPercent
            numberOfComponentProducts
          }
          fundName
        }
      }
      ogImage
      externalAdsConfig
      noIndex
    }
  }
`;
exports.GET_RICH_TEXT = `
  query getRawRichTextBySlug($slug: String, $type: String) {
    getRawRichTextBySlug(slug: $slug, type: $type) {
      name
      richTextContent
      slug
    }
  }
`;
exports.GET_TOOLKIT_PAGE = `
  query toolkitPage($slug: String) {
    toolkitPage(slug: $slug)
  }
`;
exports.GET_BRAND_IMAGE = `
  query brandImages($name: String) {
    brandImages(name: $name)
  }
`;
exports.GET_CONTENT_BLOGS = `
  query getContentBlogs($page: Int, $perPage: Int) {
    getContentBlogs(page: $page, perPage: $perPage) {
      results {
        id,
        title,
        subtitle,
        description,
        availableFormat,
        level,
        variantsCount,
        startDate,
        endDate,
        prices {
          currency
          amount
          channel {
            applicableUserRoles
            id
          }
        },
        externalUrl,
        contentSource,
        credits,
        contentfulType,
        contentType {
          name
          slug
        },
        slug,
        image: featuredImage {
          altText
          caption
          credit
          title
          url
        }
        contentCategory {
          name
          slug
        }
        topics {
          id,
          name,
          slug
        }
        subtopics {
          id,
          name,
          slug
          topicId
          topicSlug
        },
        roles,
        matchedRoles,
        isLocked,
        timeToConsume,
        dateCreated,
        productType,
        country,
        conferenceState,
        conferenceCity,
        fundName,
        downloads{
          fileSize
        },
        parentProductInfo {
          sessions,
          upcomingDates
        },
        restrictionDetails {
          role
          membershipType
          learnMoreUrl
        },
        topicalSubscriptions,
        hasSectionAccessRestriction,
      },
      meta {
        total,
        perPage,
        page
      }
    }
  }
`;
exports.QUERY_STATIC_LANDING_PAGE = `
  query getStaticLandingPage($slug: String!) {
    getStaticLandingPage(slug: $slug)
  }
`;
const QUERY_MEMBERSHIP_PRODUCT_BLOCK = (slug) => `
  query block{
    block(path: "content/${slug}?type=membershipProductsBlock")
  }
`;
exports.QUERY_MEMBERSHIP_PRODUCT_BLOCK = QUERY_MEMBERSHIP_PRODUCT_BLOCK;
const QUERY_MEMBERSHIP_TIER_BENEFITS = (slug) => `
  query content{
    content(path: "content/${slug}?type=product")
  }
`;
exports.QUERY_MEMBERSHIP_TIER_BENEFITS = QUERY_MEMBERSHIP_TIER_BENEFITS;
exports.GET_PROMOCODE_DETAILS_BY_PROMOCODE = `
  query getPromoCodeDetails($promoCode: String) {
    getPromoCodeDetails(promoCode: $promoCode) {
      custom {
        type {
          typeId
          id
        }
        fields {
          organization
          tuition_provider
          flp_reseller
        }
      }
    }
  }
  `;
exports.GET_CONTENTFUL_PRODUCT = `
    query getContentfulProductData($slug: String) {
      getContentItemBySlug(slug: $slug, type: "product") {
        name
        subtitle
        description
        image {
          altText
          caption
          credit
          title
          url
        }
        slug
        benefits ${benefitsSubBlock}
        benefitsAccessLinks {
          name
          header
          description
          url
          group
        }
      }
    }
  `;
exports.QUERY_ENTRY_LEVEL = `
query getEntryLevels($slug: String) {
  getEntryLevels(slug: $slug) {
    name,
    pathwaySlug,
    exemptionLevel1,
    exemptionLevel2,
    exemptionLevel3,
    exemptionLevel4,
    exemptionLevel5,
    exemptionLevel6,
    exemptionLevel7,
    exemptionLevel1ShortDescription,
    exemptionLevel2ShortDescription,
    exemptionLevel3ShortDescription,
    exemptionLevel4ShortDescription,
    exemptionLevel5ShortDescription,
    exemptionLevel6ShortDescription,
    exemptionLevel7ShortDescription
  }
}
`;
exports.QUERY_ATTESTATIONS = `
query queryAttestations($attestationsToQuery: Attestations) {
  queryAttestations(attestationsToQuery: $attestationsToQuery) {
    journey {
      name
      categoryName
      categoryValue
      recordType
      attestationText
    },
    membershiptype {
      name
      categoryName
      categoryValue
      recordType
      attestationText
    },
    pathway {
      name
      categoryName
      categoryValue
      recordType
      attestationText
    },
    exemptiontype {
      name
      categoryName
      categoryValue
      recordType
      attestationText
    },
    documentstatus {
      name
      categoryName
      categoryValue
      recordType
      attestationText
    },
    donation {
      name
      categoryName
      categoryValue
      recordType
      attestationText
    },
    generic {
      name
      categoryName
      categoryValue
      recordType
      attestationText
    }
  }
}
`;
exports.QUERY_PICK_LIST = `
query getPickList($pickListId: String, $sort: SortOrder) {
  getPickList(pickListId: $pickListId, sort: $sort) {
    pickListId
    values {
      key
      value
      hidden
    }
  }
}
`;
//# sourceMappingURL=content-queries.js.map